import { Accessor, SapVersion } from "../../types/types";

export interface BaseProperty {
	id: number;
	uprn?: string;
	o_uprn?: string;
	c_uprn?: string;
	rrn?: string;
	sap_version?: SapVersion;
	sap_is_rdsap?: boolean;
	group_names?: string;
	bulk_custom_improvements_update_batch_uuid?: string;
}

type ValuesByAccessor = {
	[K in Accessor]?: string | number | null;
};

export type Property = BaseProperty & ValuesByAccessor;
export const basePropertyKeys: (keyof Required<BaseProperty>)[] = [
	"id",
	"uprn",
	"o_uprn",
	"c_uprn",
	"rrn",
	"sap_version",
	"sap_is_rdsap",
	"group_names",
	"bulk_custom_improvements_update_batch_uuid",
];

export const isBasePropertyKey = (key: string): key is keyof BaseProperty => {
	return basePropertyKeys.includes(key as any);
};
